<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-inside: avoid;text-align: center;margin: 0;">
<a href="https://link.lithub.com/join/signup?utm_campaign=9780802192370" target="_blank">
<img alt="image" src="grove-atlantic-lithub-creative.jpg" style="max-width:100%;max-height:100%;"/></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// groveatlanticlithub.vue?5989a231